__turbopack_context__.v({
  "actionButton": "header-module__mXjTjW__actionButton",
  "actions": "header-module__mXjTjW__actions",
  "desktopAccount": "header-module__mXjTjW__desktopAccount",
  "desktopNav": "header-module__mXjTjW__desktopNav",
  "fixed": "header-module__mXjTjW__fixed",
  "fixedVisible": "header-module__mXjTjW__fixedVisible",
  "header": "header-module__mXjTjW__header",
  "inner": "header-module__mXjTjW__inner",
  "logoImage": "header-module__mXjTjW__logoImage",
  "logoLink": "header-module__mXjTjW__logoLink",
  "menu": "header-module__mXjTjW__menu",
  "menuLink": "header-module__mXjTjW__menuLink",
  "menuLinkActive": "header-module__mXjTjW__menuLinkActive",
  "mobileLead": "header-module__mXjTjW__mobileLead",
  "sentinel": "header-module__mXjTjW__sentinel",
  "wordmark": "header-module__mXjTjW__wordmark",
  "wrapper": "header-module__mXjTjW__wrapper",
});
